
import {
  HashRouter,
  Route,
  Routes
} from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import SmokeRoom from './pages/smoke-room';
import Thanks from './pages/thanks';
import Home from './pages/index';
import './App.css';

function App() {
  return (
    <div className="app">
      <Helmet>
        <html lang="ja" />
        <link rel="icon" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
      </Helmet>
      <header className="site-header">
        <a className="site-header__logo" href={`${process.env.PUBLIC_URL}`}><img src={`${process.env.PUBLIC_URL}/images/logo.svg`} alt="避難行動に関するアンケート" /></a>
      </header>
      <HashRouter>
        <Routes>
          <Route path={``} element={<Home />} />
          <Route path={`smoke-room`} element={<SmokeRoom />} />
          <Route path={`thanks`} element={<Thanks />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
